import { X } from "lucide-react";
import { useState } from "react";
import { useSite } from "@/context/SiteContext";

export default function AnnouncementBar() {
  const { content } = useSite();
  const [hidden, setHidden] = useState(false);
  if (!content.announcement_enabled || !content.announcement || hidden) return null;
  return (
    <div className="bg-[var(--ink)] text-[#F4EFE3] text-xs sm:text-sm" data-testid="announcement-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-center gap-3 relative">
        <span className="w-2 h-2 rounded-full bg-[var(--marigold)] animate-pulse shrink-0" />
        <span className="font-medium text-center" data-testid="announcement-text">{content.announcement}</span>
        <button onClick={() => setHidden(true)} className="absolute right-3 p-1 rounded-full hover:bg-white/10" aria-label="Dismiss announcement" data-testid="announcement-dismiss">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
